import React, { useState, useRef, useEffect } from "react"

import {
  Container,
  ArrowIndicator,
  Summary,
  Content,
  SummaryAndContent,
  TitleContainer,
  PreHeading,
  ReadMore,
  PaddedContainer,
  Title,
} from "./styles"

const GridAccordionItem = ({
  className,
  title,
  content,
  isArticleFAQ,
  singleCol,
  preheading,
  children,
}) => {
  const [isExpanded, setExpanded] = useState(false)
  const [contentHeight, setContentHeight] = useState(0)

  const contentRef = useRef(null)
  const summaryRef = useRef(null)

  const handleExpand = (event) => {
    event.preventDefault()

    setExpanded(!isExpanded)
    setContentHeight(isExpanded ? 0 : contentRef.current.scrollHeight)
  }

  const handleKeyPress = (event) => {
    if (event.key === "Enter" || event.key === "Space") {
      handleExpand()
    }
  }

  useEffect(() => {
    const collapsedHeight = summaryRef.current.offsetHeight + (singleCol ? 0 : 85)
    setContentHeight(
      isExpanded
        ? `${contentRef.current.offsetHeight + summaryRef.current.offsetHeight}px`
        : `${collapsedHeight}px`,
    )
  }, [isExpanded, content])

  return (
    <PaddedContainer>
      <Container
        className={className}
        isArticleFAQ={isArticleFAQ}
        singleCol={singleCol}
        showPreview={!singleCol}
        isExpanded={isExpanded}
      >
        <SummaryAndContent style={{ height: contentHeight }}>
          <Summary isArticleFAQ={isArticleFAQ} onClick={handleExpand} ref={summaryRef}>
            <ArrowIndicator
              isExpanded={isExpanded}
              isArticleFAQ={isArticleFAQ}
              onKeyPress={handleKeyPress}
            />
            <TitleContainer>
              {!singleCol && <PreHeading>{preheading}</PreHeading>}
              {typeof title === "string" ? (
                <Title singleCol dangerouslySetInnerHTML={{ __html: title }} />
              ) : (
                title
              )}
            </TitleContainer>
          </Summary>
          {content ? (
            <Content ref={contentRef} dangerouslySetInnerHTML={{ __html: content }} />
          ) : (
            <Content ref={contentRef}>{children}</Content>
          )}
        </SummaryAndContent>
        {!singleCol && (
          <ReadMore isExpanded>
            <button type="button" onClick={handleExpand}>
              Read {isExpanded ? "less" : "more"}
            </button>
          </ReadMore>
        )}
      </Container>
    </PaddedContainer>
  )
}

export default GridAccordionItem
